module.exports = __webpack_public_path__ + "assets/img/ttl-footer02.svg";